/* ============================================
   DRIFT Theme by WEBEXP, LLC
   Cart Drawer — AJAX cart with dropdown panel
   V3: Cart Upsell / Cross-Sell
   https://webexp.dev
   ============================================ */

(function () {
  'use strict';

  /* ── DOM ── */
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('[data-cart-panel]');
  var backdrop = drawer.querySelector('[data-cart-backdrop]');
  var closeBtn = drawer.querySelector('[data-cart-close]');
  var itemsWrap = drawer.querySelector('[data-cart-items]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var footerEl = drawer.querySelector('[data-cart-footer]');
  var checkoutBtn = drawer.querySelector('[data-cart-checkout]');

  /* Free shipping bar */
  var shippingBar = drawer.querySelector('[data-cart-shipping]');
  var shippingText = drawer.querySelector('[data-cart-shipping-text]');
  var shippingFill = drawer.querySelector('[data-cart-shipping-fill]');
  var shippingThreshold = shippingBar
    ? parseFloat(shippingBar.getAttribute('data-shipping-threshold')) || 0
    : 0;

  /* Upsell */
  var upsellWrap = drawer.querySelector('[data-cart-upsell]');
  var upsellToggle = drawer.querySelector('[data-cart-upsell-toggle]');
  var upsellBody = drawer.querySelector('[data-cart-upsell-body]');
  var upsellScroll = drawer.querySelector('[data-cart-upsell-scroll]');
  /* Default-expanded state is per-viewport. We resolve once on init. */
  var upsellExpanded = false;
  if (upsellWrap) {
    var isDesktop = window.innerWidth >= 1025;
    var attr = isDesktop
      ? 'data-upsell-default-expanded-desktop'
      : 'data-upsell-default-expanded-mobile';
    upsellExpanded = upsellWrap.getAttribute(attr) === 'true';
    if (upsellExpanded) {
      upsellWrap.classList.add('is-expanded');
      if (upsellToggle) upsellToggle.setAttribute('aria-expanded', 'true');
    }
  }
  var upsellLimit = upsellWrap
    ? parseInt(upsellWrap.getAttribute('data-upsell-limit'), 10) || 4
    : 4;
  var lastUpsellFingerprint = null;

  /* Cart bubble(s) in header */
  var cartBubbleLinks = document.querySelectorAll('[data-cart-bubble]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  /* ── State ── */
  var isOpen = false;
  var cart = null;
  var lastCartToken = null;
  var productCache = {};

  /* ========================================
     OPEN / CLOSE
     ======================================== */

  function open() {
    if (isOpen) return;
    isOpen = true;
    drawer.setAttribute('aria-hidden', 'false');
    if (window.innerWidth < 1025) {
      document.body.style.overflow = 'hidden';
    }
    var header = document.querySelector('.drift-header');
    if (header && header.hasAttribute('data-menu-open')) {
      header.removeAttribute('data-menu-open');
    }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    var pdpExpanded = document.querySelector('.drift-pdp__panel.is-expanded');
    if (!pdpExpanded) {
      document.body.style.overflow = '';
    }
  }

  function toggle() {
    if (isOpen) close();
    else {
      fetchAndRender();
      open();
    }
  }

  /* ========================================
     EVENT LISTENERS
     ======================================== */

  if (panel) {
    panel.addEventListener('touchmove', function (e) {
      if (!isOpen) return;
      var items = panel.querySelector('[data-cart-items]');
      if (!items) return;
      if (items.scrollHeight > items.clientHeight) {
        e.stopPropagation();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  if (backdrop) {
    backdrop.addEventListener('touchmove', function (e) {
      if (isOpen) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  cartBubbleLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
  });

  document.addEventListener('cart:updated', function () {
    fetchAndRender();
    open();
  });

  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (panel && panel.contains(e.target)) return;
    var clickedBubble = false;
    cartBubbleLinks.forEach(function (link) {
      if (link.contains(e.target)) clickedBubble = true;
    });
    if (clickedBubble) return;
    close();
  });

  /* Upsell toggle */
  if (upsellToggle) {
    upsellToggle.addEventListener('click', function () {
      upsellExpanded = !upsellExpanded;
      upsellToggle.setAttribute('aria-expanded', upsellExpanded ? 'true' : 'false');
      if (upsellWrap) {
        if (upsellExpanded) upsellWrap.classList.add('is-expanded');
        else upsellWrap.classList.remove('is-expanded');
      }
    });
  }

  /* ========================================
     FETCH CART + RENDER
     ======================================== */

  function fetchAndRender() {
    Promise.all([
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/?sections=drift-cart-items', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ])
      .then(function (results) {
        cart = results[0];
        var sections = results[1] || {};
        renderCart(sections['drift-cart-items']);
        updateShippingBar();
        syncBubbles();
        fetchUpsell();
      })
      .catch(function () {});
  }

  function renderCart(sectionHtml) {
    if (!cart || !itemsWrap) return;

    var token = cart.items.map(function (i) {
      return i.key + ':' + i.quantity;
    }).join(',') + '|' + cart.total_price;

    if (token === lastCartToken) return;
    lastCartToken = token;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<span class="drift-cart__empty">Cart is empty</span>';
      if (footerEl) footerEl.style.display = 'none';
      if (shippingBar) shippingBar.setAttribute('hidden', '');
      hideUpsell();
      return;
    }

    if (footerEl) footerEl.style.display = '';

    if (sectionHtml) {
      var temp = document.createElement('span');
      temp.innerHTML = sectionHtml;
      var renderItems = temp.querySelector('[data-cart-render-items]');
      var renderSubtotal = temp.querySelector('[data-cart-render-subtotal]');
      if (renderItems) {
        itemsWrap.innerHTML = renderItems.innerHTML;
      }
      if (subtotalEl && renderSubtotal) {
        subtotalEl.innerHTML = renderSubtotal.innerHTML;
      }
    }

    bindItemEvents();
  }

  /* ========================================
     FREE SHIPPING BAR
     ======================================== */

  function updateShippingBar() {
    if (!shippingBar || !shippingText || !shippingFill || !cart) return;
    if (shippingThreshold <= 0) return;

    if (cart.item_count === 0) {
      shippingBar.setAttribute('hidden', '');
      return;
    }

    shippingBar.removeAttribute('hidden');

    var totalDollars = cart.total_price / 100;
    var remaining = shippingThreshold - totalDollars;
    var pct = Math.min((totalDollars / shippingThreshold) * 100, 100);

    var currencyCode = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active)
      ? Shopify.currency.active
      : 'USD';

    if (remaining <= 0) {
      shippingBar.classList.add('is-met');
      shippingText.innerHTML = '<svg class="drift-cart__shipping-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Free shipping unlocked';
      shippingFill.style.width = '100%';
    } else {
      shippingBar.classList.remove('is-met');
      var formattedRemaining = formatCurrency(remaining, currencyCode);
      shippingText.textContent = 'You\u2019re ' + formattedRemaining + ' away from free shipping';
      shippingFill.style.width = pct + '%';
    }
  }

  function formatCurrency(amount, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  /* ========================================
     CART UPSELL / CROSS-SELL (V3)
     ======================================== */

  function fetchUpsell() {
    if (!upsellWrap || !upsellScroll || !cart || cart.item_count === 0) {
      hideUpsell();
      return;
    }

    var cartProductIds = cart.items.map(function (i) { return i.product_id; });
    var cartFingerprint = cartProductIds.slice().sort().join(',');

    if (cartFingerprint === lastUpsellFingerprint) return;
    lastUpsellFingerprint = cartFingerprint;

    var uniqueIds = [];
    cartProductIds.forEach(function (id) {
      if (uniqueIds.indexOf(id) === -1) uniqueIds.push(id);
    });

    var fetches = uniqueIds.map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.products || []; })
        .catch(function () { return []; });
    });

    Promise.all(fetches).then(function (results) {
      var seen = {};
      var merged = [];

      results.forEach(function (products) {
        products.forEach(function (p) {
          if (seen[p.id]) return;
          if (cartProductIds.indexOf(p.id) !== -1) return;
          if (!p.available) return;
          seen[p.id] = true;
          merged.push(p);
        });
      });

      if (merged.length === 0) {
        hideUpsell();
        return;
      }

      for (var i = merged.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = merged[i];
        merged[i] = merged[j];
        merged[j] = tmp;
      }

      renderUpsell(merged.slice(0, upsellLimit));
    });
  }

  function renderUpsell(products) {
    if (!upsellScroll || !upsellWrap) return;

    var html = '';

    products.forEach(function (p) {
      var img = p.featured_image
        ? getSizedImage(p.featured_image, '400x')
        : '';
      var firstVariant = p.variants && p.variants[0] ? p.variants[0] : null;
      var hasMultipleVariants = p.variants && p.variants.length > 1;
      var variantId = firstVariant ? firstVariant.id : '';
      var price = firstVariant ? firstVariant.price : p.price;

      html += '<span class="drift-cart__upsell-card">';

      html += '<a href="' + p.url + '" class="drift-cart__upsell-img-link">';
      if (img) {
        html += '<img class="drift-cart__upsell-img" src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy" width="200" height="200" draggable="false">';
      }
      html += '</a>';

      html += '<span class="drift-cart__upsell-info">';
      html += '<a href="' + p.url + '" class="drift-cart__upsell-title">' + escHtml(p.title) + '</a>';
      var compareAt = firstVariant ? firstVariant.compare_at_price : null;
      var priceHtml = '';
      if (compareAt && compareAt > price) {
        priceHtml = '<s class="drift-cart__upsell-compare">' + formatMoney(compareAt) + '</s> ' + formatMoney(price);
      } else {
        priceHtml = formatMoney(price);
      }
      html += '<span class="drift-cart__upsell-price">' + priceHtml + '</span>';
      html += '</span>';

      if (hasMultipleVariants) {
        html += '<a href="' + p.url + '" class="drift-cart__upsell-options" aria-label="View options for ' + escHtml(p.title) + '">View</a>';
      } else if (variantId) {
        html += '<button class="drift-cart__upsell-add" data-upsell-add="' + variantId + '" type="button" aria-label="Add ' + escHtml(p.title) + ' to cart">Add to Cart</button>';
      }

      html += '</span>';
    });

    upsellScroll.innerHTML = html;
    upsellWrap.removeAttribute('hidden');

    bindUpsellEvents();
  }

  function bindUpsellEvents() {
    if (!upsellScroll) return;

    var addBtns = upsellScroll.querySelectorAll('[data-upsell-add]');
    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-upsell-add');
        if (!variantId) return;

        btn.disabled = true;
        btn.classList.add('is-adding');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            lastUpsellFingerprint = null;
            fetchAndRender();
          })
          .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-adding');
          });
      });
    });
  }

  function hideUpsell() {
    if (!upsellWrap) return;
    upsellWrap.setAttribute('hidden', '');
    if (upsellScroll) upsellScroll.innerHTML = '';
    lastUpsellFingerprint = null;
  }

  /* ========================================
     ITEM EVENTS — qty + remove
     ======================================== */

  function bindItemEvents() {
    var qtyBtns = itemsWrap.querySelectorAll('[data-cart-qty]');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        var action = btn.getAttribute('data-cart-qty');
        var item = findItem(key);
        if (!item) return;

        var newQty = action === 'plus' ? item.quantity + 1 : item.quantity - 1;
        if (newQty < 1) newQty = 0;

        setItemUpdating(key, true);
        updateItem(key, newQty);
      });
    });

    var removeBtns = itemsWrap.querySelectorAll('[data-cart-remove]');
    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-key');
        setItemUpdating(key, true);
        updateItem(key, 0);
      });
    });
  }

  function findItem(key) {
    if (!cart) return null;
    return cart.items.find(function (i) { return i.key === key; }) || null;
  }

  function setItemUpdating(key, updating) {
    var el = itemsWrap.querySelector('[data-line-key="' + key + '"].drift-cart__item');
    if (!el) return;
    if (updating) el.classList.add('is-updating');
    else el.classList.remove('is-updating');
  }

  /* ========================================
     CART API — update quantity
     ======================================== */

  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'drift-cart-items' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        lastCartToken = null;
        lastUpsellFingerprint = null;
        var sections = data.sections || {};
        renderCart(sections['drift-cart-items']);
        updateShippingBar();
        syncBubbles();
        fetchUpsell();

        if (cart.item_count === 0) {
          setTimeout(close, 300);
        }
      })
      .catch(function () {
        setItemUpdating(key, false);
      });
  }

  /* ========================================
     SYNC HEADER BUBBLES
     ======================================== */

  function syncBubbles() {
    if (!cart) return;

    cartCountEls.forEach(function (el) {
      el.textContent = cart.item_count;
    });

    cartBubbleLinks.forEach(function (link) {
      if (cart.item_count > 0) link.removeAttribute('hidden');
      else link.setAttribute('hidden', '');
    });
  }

  /* ========================================
     UTILITIES
     ======================================== */

  function formatMoney(cents) {
    var rate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate)
      ? parseFloat(Shopify.currency.rate)
      : 1;
    var currencyCode = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active)
      ? Shopify.currency.active
      : 'USD';
    var amount = (cents * rate) / 100;
    var isWhole = amount === Math.floor(amount);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(isWhole ? 0 : 2);
    }
  }

  function escHtml(str) {
    var el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }

  function getSizedImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.\w{3,4})(\?.*)?\s*$/, '_' + size + '$1$2');
  }

  /* ========================================
     INIT — fetch cart state on page load
     ======================================== */

  fetchAndRender();

})();